import './MessageBody.scss';

import React, { PureComponent } from 'react';
import { Map } from 'immutable';
import PropTypes from 'prop-types';

import Box from 'components/Box';
import Button from 'components/clickables/Button';
import Image from 'components/Image';
import CoverRequestCard from 'components/messenger/CoverRequestCard';
import Text from 'components/Text';

import cxHelpers from 'util/className';

@cxHelpers('MessageBody')
export default class MessageBody extends PureComponent {
  static propTypes = {
    message: PropTypes.instanceOf(Map).isRequired,
  };

  renderShoutout = () => {
    const { message } = this.props;
    const shoutoutLabel = message.getIn(['shoutout', 'shoutout_type', 'label']);
    const shoutoutImage = message.getIn(['shoutout', 'shoutout_type', 'image']);

    return (
      <Box>
        <Text
          i18n="messenger.shoutout"
          i18nProps={{
            sender: message.getIn(['shoutout', 'sending_user', 'first_name']),
            receiver: message.getIn([
              'shoutout',
              'receiving_user',
              'first_name',
            ]),
            type: shoutoutLabel,
          }}
        />
        <Image
          // eslint-disable-next-line max-len
          src={shoutoutImage}
          h="180"
          w="180"
        />
      </Box>
    );
  };

  render() {
    const { message } = this.props;

    if (message.get('type') === 'doc_link') {
      return (
        <Box row vcenter>
          <Box row bg="primary050" pv={10} ph={18} borderbox>
            <Text fs24>
              <i className="far fa-file-alt" />
            </Text>
          </Box>

          <Box pv={10} ph={10}>
            <Button target="_blank" theme="link" href={message.get('body')}>
              {message.getIn(['meta_data', 'display_text'])}
            </Button>
          </Box>
        </Box>
      );
    } else if (message.get('attachment')) {
      return (
        <Image
          src={message.getIn(['attachment', 'preview_url'])}
          expandedSrc={message.getIn(['attachment', 'origin_url'])}
        />
      );
    } else if (message.get('cover_request')) {
      return (
        <CoverRequestCard
          coverRequest={message.get('cover_request')}
          senderName={message.get('sending_user_name')}
        />
      );
    } else if (message.get('shoutout')) {
      return this.renderShoutout();
    } else if (message.get('coordinates')) {
      return (
        <img
          src={message.getIn(['coordinates', 'static_map_url'])}
          alt="coordinates"
        />
      );
    }

    return (
      <Box>
        <Text>{message.get('body')}</Text>
      </Box>
    );
  }
}
